import React from 'react';
import GenericSetupPage from './GenericSetupPage';

const PatientFacilitiesPage = () => {
  const columns = [
    { key: 'name', label: 'Facility Name' },
    { key: 'type', label: 'Facility Type' },
    { key: 'address', label: 'Address' },
    { key: 'phone', label: 'Phone' },
    { key: 'npi', label: 'NPI' },
    { key: 'active', label: 'Active' },
  ];

  const formFields = [
    { key: 'name', label: 'Facility Name', type: 'text', required: true },
    { key: 'type', label: 'Facility Type', type: 'select', required: true, options: [
      { value: 'Hospital', label: 'Hospital' },
      { value: 'SNF', label: 'Skilled Nursing Facility' },
      { value: 'ALF', label: 'Assisted Living Facility' },
      { value: 'Rehab', label: 'Rehabilitation Center' },
      { value: 'LTACH', label: 'Long Term Acute Care' },
      { value: 'Hospice', label: 'Hospice Facility' },
      { value: 'Other', label: 'Other' },
    ]},
    { key: 'address', label: 'Address', type: 'text', required: true },
    { key: 'city', label: 'City', type: 'text', required: true },
    { key: 'state', label: 'State', type: 'text', required: true },
    { key: 'zip', label: 'ZIP', type: 'text', required: true },
    { key: 'phone', label: 'Phone', type: 'text', required: true },
    { key: 'fax', label: 'Fax', type: 'text', required: false },
    { key: 'npi', label: 'NPI', type: 'text', required: false },
    { key: 'active', label: 'Active', type: 'select', required: true, options: [
      { value: 'Yes', label: 'Yes' },
      { value: 'No', label: 'No' }
    ]}
  ];

  const initialData = [
    { id: '1', name: 'Memorial Hermann Hospital', type: 'Hospital', address: '6411 Fannin St, Houston TX', phone: '(713) 704-4000', npi: '1234567890', active: 'Yes' },
    { id: '2', name: 'Houston Methodist Hospital', type: 'Hospital', address: '6565 Fannin St, Houston TX', phone: '(713) 790-3311', npi: '2345678901', active: 'Yes' },
    { id: '3', name: 'Kindred Hospital Houston', type: 'LTACH', address: '6441 Main St, Houston TX', phone: '(713) 795-5700', npi: '3456789012', active: 'Yes' },
    { id: '4', name: 'Park Manor of Westchase', type: 'SNF', address: '11415 W Bellfort, Houston TX', phone: '(281) 879-2200', npi: '4567890123', active: 'Yes' },
    { id: '5', name: 'Brookdale Memorial City', type: 'ALF', address: '901 S Kirkwood Rd, Houston TX', phone: '(713) 464-0646', npi: '5678901234', active: 'Yes' },
    { id: '6', name: 'TIRR Memorial Hermann', type: 'Rehab', address: '1333 Moursund St, Houston TX', phone: '(713) 799-5000', npi: '6789012345', active: 'Yes' },
  ];

  return (
    <GenericSetupPage
      title="Patient Facilities"
      columns={columns}
      initialData={initialData}
      addButtonText="Add Facility"
      formFields={formFields}
      apiEndpoint="/setup/patient-facilities"
    />
  );
};

export default PatientFacilitiesPage;
